module.exports = __webpack_public_path__ + "img/rightWhite.88e7a686.svg";